import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Autoplay, EffectCoverflow, Pagination } from 'swiper/modules';

const images = [
  '/images/banner1.jpg',
  '/images/banner2.jpg',
  '/images/banner3.jpg',
];



const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const defaultCategoriesImages = [
    'https://images.unsplash.com/photo-1497493292307-31c376b6e479?auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1505797149-43b0069ec26b?auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?auto=format&fit=crop&w=800&q=80',
    '/images/5.jpg',
  ];

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axiosInstance.get('/categories');
        setCategories(data);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch categories', err);
        setError('Failed to load categories. Please try again later.');
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return (
      <Container className="d-flex justify-content-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <div className="alert alert-danger">{error}</div>
      </Container>
    );
  }

  return (
    <div>
    {/* Hero Section */}
    <Swiper
     effect="coverflow"
     grabCursor
     centeredSlides
     slidesPerView="auto"
     coverflowEffect={{
       rotate: 0,
       stretch: 0,
       depth: 100,
       modifier: 2.5,
     }}
     loop
     autoplay={{
       delay: 2000,
       disableOnInteraction: false,
     }}
      pagination={true} // 🔘 dots here
      modules={[Autoplay, EffectCoverflow, Pagination]}
      className="mySwiper"
    >
      {images.map((src, index) => (
        <SwiperSlide key={index}>
            <img src={src} alt={`Slide ${index}`} style={{ height: '656px', width: '100%' }} />
        </SwiperSlide>
      ))}
    </Swiper>

    <Container className="py-4">
    <h1 className="mb-4 text-center">Browse Categories</h1>
      
      <Row style={{display: 'flex', justifyContent: 'center'}}>
        {categories.map((category, index) => {
          const defaultImage = defaultCategoriesImages[index % defaultCategoriesImages.length];
          
          return(
          <Col md={4} key={category.id} className="mb-4">
            <Card className="h-100 shadow-sm hover:shadow-lg transition-shadow">
              <Link to={`/categories/${category.id}`} className="text-decoration-none">
                <Card.Img 
                  variant="top" 
                  src={category.image_url ||defaultImage} 
                  alt={category.name}
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="text-center mb-3">{category.name}</Card.Title>
                  <Card.Text className="text-muted flex-grow-1">
                    {category.description || `Browse our collection of ${category.name}`}
                  </Card.Text>
                  <div className="text-center mt-auto pt-3">
                    <div className="btn btn-outline-primary">View Products</div>
                  </div>
                </Card.Body>
              </Link>
            </Card>
          </Col>
        )})}
      </Row>
    </Container>
    </div>
  );
};

export default CategoriesPage; 